// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"3845a5b8","348":"844bba64","381":"f54c0dec","836":"4b09b52b","887":"7b44a2d5","918":"b6bbf2af"}[chunkId] + ".chunk.js";
};